import React from 'react'
import { useTranslation } from 'react-i18next'

import { usePdfOptionsForm, usePdfOptionsFormActions } from './_form/PdfOptionsFormHandler'
import CheckboxListItem from '../../list/CheckboxListItem'
import DropdownListItem from '../../list/DropdownListItem'

const PdfBasicOptionsForm = () => {
  const form = usePdfOptionsForm()
  const { handleChange } = usePdfOptionsFormActions()
  const { t } = useTranslation('components')

  const sizes = {
    verySmall: t('pdf.options.size.verySmall'),
    small: t('pdf.options.size.small'),
    standard: t('pdf.options.size.standard'),
    medium: t('pdf.options.size.medium'),
    large: t('pdf.options.size.large'),
    veryLarge: t('pdf.options.size.veryLarge'),
    giant: t('pdf.options.size.giant')
  }

  const imagesHeightOptions = [
    { label: t('pdf.options.realSize'), value: 0 },
    { label: t('pdf.options.sizeWithPx', { size: sizes.verySmall, px: 150 }), value: '150px' },
    { label: t('pdf.options.sizeWithPx', { size: sizes.small, px: 200 }), value: '200px' },
    { label: t('pdf.options.sizeWithPx', { size: sizes.medium, px: 250 }), value: '250px' },
    { label: t('pdf.options.sizeWithPx', { size: sizes.large, px: 300 }), value: '300px' },
    { label: t('pdf.options.sizeWithPx', { size: sizes.veryLarge, px: 350 }), value: '350px' },
    { label: t('pdf.options.sizeWithPx', { size: sizes.giant, px: 400 }), value: '400px' }
  ]

  const imagesPerRowOptions = [1, 2, 3, 4, 5].map(count => ({ label: t('pdf.options.perLine', { count }), value: count }))

  const fontSizes = [
    { label: t('pdf.options.sizeWithNumber', { size: sizes.verySmall, value: 10 }), value: 10 },
    { label: t('pdf.options.sizeWithNumber', { size: sizes.small, value: 12 }), value: 12 },
    { label: t('pdf.options.sizeWithNumber', { size: sizes.standard, value: 14 }), value: 14 },
    { label: t('pdf.options.sizeWithNumber', { size: sizes.medium, value: 16 }), value: 16 },
    { label: t('pdf.options.sizeWithNumber', { size: sizes.large, value: 18 }), value: 18 },
    { label: t('pdf.options.sizeWithNumber', { size: sizes.veryLarge, value: 20 }), value: 20 }
  ]

  return (
    <div>
      <CheckboxListItem
        selected={form.enableNoWrap}
        onSelect={handleChange('enableNoWrap')}
        label={t('pdf.autoPageBreak')}
        invert
      />

      <DropdownListItem
        onChange={handleChange('fontBase')}
        label={t('pdf.baseFontSize')}
        value={form.fontBase || 14}
        options={fontSizes}
        invert
      />

      <CheckboxListItem
        selected={form.hasColors}
        onSelect={handleChange('hasColors')}
        label={t('pdf.enableColors')}
        invert
      />

      <CheckboxListItem
        selected={form.showImages}
        onSelect={handleChange('showImages')}
        label={t('pdf.showImages')}
        invert
      />

      <CheckboxListItem
        selected={form.showSign}
        onSelect={handleChange('showSign')}
        label={t('pdf.showSignature')}
        invert
      />

      <DropdownListItem
        onChange={handleChange('imagesHeight')}
        label={t('pdf.imageHeight')}
        value={form.imagesHeight ?? 0}
        options={imagesHeightOptions}
        invert
      />

      <DropdownListItem
        onChange={handleChange('imagesPerRow')}
        label={t('pdf.itemsPerLine')}
        value={form.imagesPerRow}
        options={imagesPerRowOptions}
        invert
      />
    </div>
  )
}

export default PdfBasicOptionsForm
